// /opt/ptg01-v1/packages/ui/src/NexviaLogo.tsx
// Logo Nexvia Portage — version canonique partagée par les 4 apps.
// Pattern : N bleu #000091 sur carré rond légèrement rotatif + "nexvia" noir + "Portage" + 3 dots (bleu/blanc/rouge, tricolore FR).
import React from 'react';

export const NexviaLogo = () => (
    <div className="flex items-center gap-3 select-none cursor-pointer">
        <div className="relative w-9 h-9 flex items-center justify-center">
            <div className="absolute inset-0 bg-[#000091] rounded-md transform rotate-6 shadow-sm"></div>
            <div className="absolute inset-0 bg-[#1e40af] rounded-md opacity-60 transform -rotate-3"></div>
            <span className="relative text-white font-bold text-xl font-sans">N</span>
        </div>
        <div className="flex flex-col justify-center leading-none">
            <span className="font-bold text-xl tracking-tight text-slate-900 font-sans">nexvia</span>
            <div className="flex items-center gap-1.5">
                <span className="text-[0.6rem] uppercase tracking-wider font-bold text-slate-500 font-sans">Portage</span>
                <div className="flex gap-[2px]">
                    <div className="w-1 h-1 bg-blue-600 rounded-full"></div>
                    <div className="w-1 h-1 bg-white border border-slate-300 rounded-full"></div>
                    <div className="w-1 h-1 bg-red-500 rounded-full"></div>
                </div>
            </div>
        </div>
    </div>
);
